import { ChipsItem } from '@wellesley/ui'
import { Info } from 'lucide-react'

export const FooterCaption = () => {
  return (
    <div className="pointer-events-none flex items-center gap-xxxs border-t  border-gray-200 px-m pb-xxs pt-s text-xs text-gray-500">
      <Info size={16} /> To find content with tags, start your search with{' '}
      <ChipsItem text="#" />
    </div>
  )
}
